import { BaseMessage } from './base.js';
export class SdpAnswerMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get senderId() {
        return this.payload.senderId;
    }
    get sdp() {
        return this.payload.sdp;
    }
    get type() {
        return this.payload.type;
    }
}
